import axios from 'axios';
import { SECRETS_MANAGER_REST_API_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'vf-trace-transaction-id': crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const retrieveSecrets = async (secretName) => {
  const response = await axios.get(SECRETS_MANAGER_REST_API_URL, {
    params: { secretName },
    headers: getHeaders(),
  });
  return response.data;
};

export const createSecret = async (secretName, secretValue) => {
  const response = await axios.post(`${SECRETS_MANAGER_REST_API_URL}/create`, secretValue, {
    params: { secretName },
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const updateSecret = async (secretName, secretValue) => {
  const response = await axios.post(`${SECRETS_MANAGER_REST_API_URL}/update`, secretValue, {
    params: { secretName },
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const rollbackSecret = async (secretName) => {
  const response = await axios.get(`${SECRETS_MANAGER_REST_API_URL}/roll-back`, {
    params: { secretName },
    headers: getHeaders(),
  });
  return response.data;
};
